import React from "react"
import { Link } from "gatsby"
import { Container, Box } from "theme-ui"
import styled from "@emotion/styled"

const Wrapper = styled.div`
    padding: 2rem 0;
    margin-bottom: 10rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: ${(props) => props.theme.colors.soft_green};
    min-height: 350px;
    & img {
        max-width: 100%;
        height: auto;
    }
    & h1 {
        color: ${(props) => props.theme.colors.primary};
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        padding: 0;
        margin-top: 1rem;
    }
`

const GetHelpBox = styled.div`
    border: 1px solid #d1d2d4;
    background: #f6f6f6;
    border-radius: 2rem;
    display: flex;
    margin: 2rem;

    & img {
        border-radius: 2rem 0 0 2rem;
        max-width: 350px;
    }

    & h3 {
        color: ${(props) => props.theme.colors.primary};
    }
    & p {
        color: ${(props) => props.theme.colors.secondary};
        margin-bottom: 1rem;
    }
    & a.explore-more {
        background: ${(props) => props.theme.colors.secondary};
        border: 1px solid ${(props) => props.theme.colors.secondary};
        margin-top: 2rem;
        padding: 0.5rem 1.5rem;
        color: ${(props) => props.theme.colors.background};
        text-decoration: none;

        &:hover {
            text-decoration: none;
        }
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[3]}) {
        margin: 2rem;
        flex-direction: column;
        & img {
            border-radius: 2rem 2rem 0 0;
            max-width: 100%;
        }
        & > div {
            padding-bottom: 2rem;
        }
    }
`

function topBanner({ data }) {
    return (
        <Wrapper className="full-width-from-container">
            <Container>
                <GetHelpBox>
                    <img src="/get-help.jpg" alt="" />
                    <Box sx={{ padding: "1rem" }}>
                        <h3>Get Help</h3>
                        <p>
                            Find a Thrapist and get the help you need from a
                            therapist near you a FREE service from Dynamics
                            Speech Today.
                        </p>
                        <Link
                            to="/contact"
                            className="explore-more content-paragraph"
                        >
                            Read More
                        </Link>
                    </Box>
                </GetHelpBox>
            </Container>
        </Wrapper>
    )
}

export default topBanner
